import { Component, ElementRef, OnInit } from "@angular/core";
import { GlobalService } from "../../_services/global.service";
import { Router } from "@angular/router";
import { ConfigPermissionOption } from "../../_helpers/config-permission-option";
@Component({
  selector: "app-sidebar",
  templateUrl: "./app-sidebar.component.html",
  styleUrls: ["./app-sidebar.component.css"],
})
export class AppSidebar implements OnInit {
  projectId = "";
  linkPrefix = "";
  account: any;
  projects: any;
  projectKeys: Array<string>;
  differ: any;
  actionScanAccountManagement = false;
  actionSeedingAccountManager = false;
  actionViewSeedingAccount = false;
  actionVPSHostingManagement = false;
  actionPriorityListManagement = false;
  actionNewsAnalyticConfig = false;
  actionTokenManagement = false;
  actionGeneralReport = false;
  actionResponseRate = false;
  actionSeedingReport = false;
  actionGeneralTopicReport = false;
  actionProcessByProject = false;
  actionViewDashboard1 = false;
  actionViewDashboardDetail = false;
  actionViewDashboard2 = false;
  actionViewDashboard3 = false;
  actionViewDashboard4 = false;
  actionViewDashboard5 = false;
  actionViewDashboard6 = false;
  actionCommentTmpManagement = false;
  actionPostManagement = false;
  actionNewsReport = false;
  actionCrawlerReport = false;
  actionPostTemplateManagement = false;
  actionQuickresearchProject = false;
  actionSentimentReport = false;
  actionDiscussSentimentReport = false;
  actionProvinceSentimentReport = false;
  actionKriReport = false;
  actionKriMonitorReport = false;
  actionSupervisionReport = false;
  actionHearingMonitorReport = false;
  actionFollowProcessReport = false;
  actionBacklogLink = false;
  actionProjectManagement = false;
  actionProjectRoleManagement = false;
  actionDiscussionProject = false;
  actionPostNegative = false;
  actionLogManagement = false;
  actionReScan = false;
  actionAddPosts = false;
  actionBrands = false;
  actionReportManager = false;
  actionSeedingBotReport = false;
  actionArticleReport = false;
  actionTopFacebookReport = false;
  actionWeeklyReport = false;
  actionNegativeReport = false;
  // báo cáo mytv
  actionDiscussionTotalReport = false;
  actionDiscussionTvSocial = false;
  actionDiscussionTrend = false;
  actionSentimentIndex = false;
  actionTopContentDiscuss = false;
  actionBrandDataSource = false;
  // báo cáo tổng quan thương hiệu
  actionTableContent = false; // quản lý mục lục
  actionBrandReport = false; // báo cáo tổng quan
  actionOutstandingStatistics = false; // báo cáo thống kê nổi bật thương hiệu
  actionChannelDiscussion = false; //báo cáo kênh thảo luận
  actionPageAnalytic = false; //báo cáo hiệu quả bài đăng trên Fanpage
  actionUserOverview = false; //báo cáo chân dung người thảo luận
  actionCompareSource = false; //Báo cáo so sánh nguồn bài đăng
  actionDiscussDevelopmentBrands = false; //Báo cáo Diễn biến thảo luận về các thương hiệu
  actionDiscussionDevelopment = false; //Báo cáo Diễn biến thảo luận
  actionSentimentBrandReport = false; //Báo cáo So sánh sắc thái thảo luận các thương hiệu
  actionSentimentDiscussReport = false; //Báo cáo sắc thái thảo luận
  actionBrandComparison = false; // báo cáo so sánh thương hiệu
  actionDetailReport = false; //Báo cáo chi tiết nội dung theo chủ đề
  actionFeaturedContent = false; //Báo cáo nội dung thảo luận nổi bật về thương hiệu
  actionHealthBrand = false; //Báo cáo so sánh sức khỏe thương hiệu
  actionDiscussionMarketShare = false; // Báo cáo thị phần các thương hiệu
  actionComparePageAnalytic = false; // Báo cáo so sánh hình thức bài đăng trên Fanpage
  actionAutoSeeding = false; // chức năng auto seeding
  actionAutoLikePage = false;
  actionAutoFollowUser = false;
  actionAutoLikePost = false;
  actionAutoLikeComment = false;
  actionAutoShare = false;
  actionAutoComment = false;
  actionAutoPost = false;
  actionAutoJoinGroup = false;
  actionAutoDynamicScript = false;
  actionPTTTReport = false;
  actionGroupDiscussion = false;
  actionE14Report = false;
  actionUserManagement = false;
  // khai thác khách hàng tiềm năng
  actionRequestProcessing = false;
  actionConsultingHistory = false;
  actionExploitationReport = false;
  actionReportWorkPerformance = false;
  actionCreatedOrder = false;
  actionUserTimeReport = false;
  actionBrandManage = false;
  actionRoleBrand = false;
  actionDepartment = false;
  actionNewsSource = false;
  public configPermissionOption = ConfigPermissionOption;
  constructor(
    private el: ElementRef,
    private router: Router,
    private globalService: GlobalService
  ) {
    this.actionScanAccountManagement = this.globalService.canPermission(
      this.configPermissionOption.actionScanAccountManagement
    );
    this.actionSeedingAccountManager = this.globalService.canPermission(
      this.configPermissionOption.actionSeedingAccountManager
    );
    this.actionViewSeedingAccount = this.globalService.canPermission(
      this.configPermissionOption.actionViewSeedingAccount
    );
    this.actionVPSHostingManagement = this.globalService.canPermission(
      this.configPermissionOption.actionVPSHostingManagement
    );
    this.actionPriorityListManagement = this.globalService.canPermission(
      this.configPermissionOption.actionPriorityListManagement
    );
    this.actionNewsAnalyticConfig = this.globalService.canPermission(
      this.configPermissionOption.actionConfigNewsAnalytic
    );
    this.actionTokenManagement = this.globalService.canPermission(
      this.configPermissionOption.actionTokenManagement
    );
    this.actionGeneralReport = this.globalService.canPermission(
      this.configPermissionOption.actionGeneralReport
    );
    this.actionResponseRate = this.globalService.canPermission(
      this.configPermissionOption.actionResponseRate
    );
    this.actionGeneralTopicReport = this.globalService.canPermission(
      this.configPermissionOption.actionGeneralTopicReport
    );
    this.actionProcessByProject = this.globalService.canPermission(
      this.configPermissionOption.actionProcessByProject
    );
    this.actionSeedingReport = this.globalService.canPermission(
      this.configPermissionOption.actionSeedingReport
    );
    this.actionViewDashboard1 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard1
    );
    this.actionViewDashboardDetail = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboardDetail
    );
    this.actionViewDashboard2 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard2
    );
    this.actionViewDashboard3 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard3
    );
    this.actionViewDashboard4 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard4
    );
    this.actionViewDashboard5 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard5
    );
    this.actionViewDashboard6 = this.globalService.canPermission(
      this.configPermissionOption.actionViewDashboard6
    );
    this.actionCommentTmpManagement = this.globalService.canPermission(
      this.configPermissionOption.actionCommentTmpManagement
    );
    this.actionPostManagement = this.globalService.canPermission(
      this.configPermissionOption.actionPostManagement
    );
    this.actionNewsReport = this.globalService.canPermission(
      this.configPermissionOption.actionNewsReport
    );
    this.actionCrawlerReport = this.globalService.canPermission(
      this.configPermissionOption.actionCrawlerReport
    );
    this.actionPostTemplateManagement = this.globalService.canPermission(
      this.configPermissionOption.actionPostTemplateManagement
    );
    this.actionQuickresearchProject = this.globalService.canPermission(
      this.configPermissionOption.actionQuickresearchProject
    );
    this.actionSentimentReport = this.globalService.canPermission(
      this.configPermissionOption.actionSentimentReport
    );
    this.actionDiscussSentimentReport = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussSentimentReport
    );
    this.actionProvinceSentimentReport = this.globalService.canPermission(
      this.configPermissionOption.actionProvinceSentimentReport
    );
    this.actionSupervisionReport = this.globalService.canPermission(
      this.configPermissionOption.actionSupervisionReport
    );
    this.actionKriReport = this.globalService.canPermission(
      this.configPermissionOption.actionKriReport
    );
    this.actionKriMonitorReport = this.globalService.canPermission(
      this.configPermissionOption.actionKriMonitorReport
    );
    this.actionHearingMonitorReport = this.globalService.canPermission(
      this.configPermissionOption.actionHearingMonitorReport
    );
    this.actionFollowProcessReport = this.globalService.canPermission(
      this.configPermissionOption.actionFollowProcessReport
    );
    this.actionBacklogLink = this.globalService.canPermission(
      this.configPermissionOption.actionBacklogLink
    );
    this.actionProjectManagement = this.globalService.canPermission(
      this.configPermissionOption.actionProjectManagement
    );
    this.actionProjectRoleManagement = this.globalService.canPermission(
      this.configPermissionOption.actionProjectRoleManagement
    );
    this.actionDiscussionProject = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionProject
    );
    this.actionPostNegative = this.globalService.canPermission(
      this.configPermissionOption.actionPostNegative
    );
    this.actionLogManagement = this.globalService.canPermission(
      this.configPermissionOption.actionLogManagement
    );
    this.actionReScan = this.globalService.canPermission(
      this.configPermissionOption.actionReScan
    );
    this.actionAddPosts = this.globalService.canPermission(
      this.configPermissionOption.actionAddPosts
    );
    this.actionBrands = this.globalService.canPermission(
      this.configPermissionOption.actionBrands
    );
    this.actionReportManager = this.globalService.canPermission(
      this.configPermissionOption.actionReportManager
    );
    this.actionSeedingBotReport = this.globalService.canPermission(
      this.configPermissionOption.actionSeedingBotReport
    );
    this.actionArticleReport = this.globalService.canPermission(
      this.configPermissionOption.actionArticleReport
    );
    this.actionTopFacebookReport = this.globalService.canPermission(
      this.configPermissionOption.actionTopFacebookReport
    );
    this.actionWeeklyReport = this.globalService.canPermission(
      this.configPermissionOption.actionWeeklyReport
    );
    this.actionNegativeReport = this.globalService.canPermission(
      this.configPermissionOption.actionNegativeReport
    );

    // báo cáo my tv
    this.actionDiscussionTotalReport = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionTotalReport
    );
    this.actionDiscussionTvSocial = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionTvSocial
    );
    this.actionDiscussionTrend = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionTrend
    );
    this.actionSentimentIndex = this.globalService.canPermission(
      this.configPermissionOption.actionSentimentIndex
    );
    this.actionTopContentDiscuss = this.globalService.canPermission(
      this.configPermissionOption.actionTopContentDiscuss
    );
    this.actionBrandDataSource = this.globalService.canPermission(
      this.configPermissionOption.actionBrandDataSource
    );

    // báo cáo tổng quan thương hiệu
    this.actionTableContent = this.globalService.canPermission(
      this.configPermissionOption.actionTableContent
    ); // quản lý mục lục
    this.actionBrandReport = this.globalService.canPermission(
      this.configPermissionOption.actionBrandReport
    ); // báo cáo tổng quan
    this.actionOutstandingStatistics = this.globalService.canPermission(
      this.configPermissionOption.actionOutstandingStatistics
    ); // báo cáo thống kê nổi bật thương hiệu
    this.actionChannelDiscussion = this.globalService.canPermission(
      this.configPermissionOption.actionChannelDiscussion
    ); //báo cáo kênh thảo luận
    this.actionPageAnalytic = this.globalService.canPermission(
      this.configPermissionOption.actionPageAnalytic
    ); //báo cáo hiệu quả bài đăng trên Fanpage
    this.actionUserOverview = this.globalService.canPermission(
      this.configPermissionOption.actionUserOverview
    ); //báo cáo chân dung người thảo luận
    this.actionCompareSource = this.globalService.canPermission(
      this.configPermissionOption.actionCompareSource
    ); //Báo cáo so sánh nguồn bài đăng
    this.actionDiscussDevelopmentBrands = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussDevelopmentBrands
    ); //Báo cáo Diễn biến thảo luận về các thương hiệu
    this.actionDiscussionDevelopment = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionDevelopment
    ); //Báo cáo Diễn biến thảo luận
    this.actionSentimentBrandReport = this.globalService.canPermission(
      this.configPermissionOption.actionSentimentBrandReport
    ); //Báo cáo So sánh sắc thái thảo luận các thương hiệu
    this.actionSentimentDiscussReport = this.globalService.canPermission(
      this.configPermissionOption.actionSentimentDiscussReport
    ); //Báo cáo sắc thái thảo luận
    this.actionBrandComparison = this.globalService.canPermission(
      this.configPermissionOption.actionBrandComparison
    ); // báo cáo so sánh thương hiệu
    this.actionDetailReport = this.globalService.canPermission(
      this.configPermissionOption.actionDetailReport
    ); //Báo cáo chi tiết nội dung theo chủ đề
    this.actionFeaturedContent = this.globalService.canPermission(
      this.configPermissionOption.actionFeaturedContent
    ); //Báo cáo nội dung thảo luận nổi bật về thương hiệu
    this.actionHealthBrand = this.globalService.canPermission(
      this.configPermissionOption.actionHealthBrand
    ); //Báo cáo so sánh sức khỏe thương hiệu
    this.actionDiscussionMarketShare = this.globalService.canPermission(
      this.configPermissionOption.actionDiscussionMarketShare
    ); //Báo cáo thị phần các thương hiệu
    this.actionComparePageAnalytic = this.globalService.canPermission(
      this.configPermissionOption.actionComparePageAnalytic
    ); //Báo cáo so sánh hình thức bài đăng trên Fanpage
    this.actionAutoSeeding = this.globalService.canPermission(
      this.configPermissionOption.actionAutoSeeding
    ); //action auto seeding
    this.actionAutoLikePage = this.globalService.canPermission(
      this.configPermissionOption.actionAutoLikePage
    );
    this.actionAutoFollowUser = this.globalService.canPermission(
      this.configPermissionOption.actionAutoFollowUser
    );
    this.actionAutoLikePost = this.globalService.canPermission(
      this.configPermissionOption.actionAutoLikePost
    );
    this.actionAutoLikeComment = this.globalService.canPermission(
      this.configPermissionOption.actionAutoLikeComment
    );
    this.actionAutoShare = this.globalService.canPermission(
      this.configPermissionOption.actionAutoShare
    );
    this.actionAutoComment = this.globalService.canPermission(
      this.configPermissionOption.actionAutoComment
    );
    this.actionAutoPost = this.globalService.canPermission(
      this.configPermissionOption.actionAutoPost
    );
    this.actionAutoJoinGroup = this.globalService.canPermission(
      this.configPermissionOption.actionAutoJoinGroup
    );
    this.actionAutoDynamicScript = this.globalService.canPermission(
      this.configPermissionOption.actionAutoDynamicScript
    );

    this.actionPTTTReport = this.globalService.canPermission(
      this.configPermissionOption.actionPTTTReport
    );
    this.actionGroupDiscussion = this.globalService.canPermission(
      this.configPermissionOption.actionGroupDiscussion
    );
    this.actionE14Report = this.globalService.canPermission(
      this.configPermissionOption.actionE14Report
    );
    this.actionUserManagement = this.globalService.canPermission(
      this.configPermissionOption.actionUserManagement
    );

    // khai thác khách hàng tiềm năng
    this.actionRequestProcessing = this.globalService.canPermission(
      this.configPermissionOption.actionRequestProcessing
    );
    this.actionConsultingHistory = this.globalService.canPermission(
      this.configPermissionOption.actionConsultingHistory
    );
    this.actionExploitationReport = this.globalService.canPermission(
      this.configPermissionOption.actionExploitationReport
    );
    this.actionReportWorkPerformance = this.globalService.canPermission(
      this.configPermissionOption.actionReportWorkPerformance
    );
    this.actionCreatedOrder = this.globalService.canPermission(
      this.configPermissionOption.actionCreatedOrder
    );
    this.actionUserTimeReport = this.globalService.canPermission(
      this.configPermissionOption.actionUserTimeReport
    );
    this.actionRoleBrand = this.globalService.canPermission(
      this.configPermissionOption.actionRoleBrand
    );
    this.actionBrandManage = this.globalService.canPermission(
      this.configPermissionOption.actionBrandManage
    );
    this.actionDepartment = this.globalService.canPermission(
      this.configPermissionOption.actionDepartment
    );
    this.actionNewsSource = this.globalService.canPermission(
      this.configPermissionOption.actionNewsSource
    );
  }
  // wait for the component to render completely
  ngOnInit(): void {
    const nativeElement: HTMLElement = this.el.nativeElement,
      parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
    const routers = this.router.url.split("/");
    if (routers.indexOf("project") > -1) {
      this.linkPrefix = "/project/" + routers[2];
      this.projectId = routers[2];
    }
    this.account =
      localStorage.getItem("currentSmmAccount") !== undefined &&
      localStorage.getItem("currentSmmAccount") !== "undefined"
        ? JSON.parse(localStorage.getItem("currentSmmAccount"))
        : {};
    if (this.globalService.projects) {
      this.projects = this.globalService.projects;
      this.projectKeys = Object.keys(this.projects);
    } else {
      this.globalService.projectLoaded$.subscribe((res) => {
        this.projects = res;
        this.projectKeys = Object.keys(this.projects);
      });
    }
  }
  public reload(href) {
    window.location.href = href;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-sidebar/app-sidebar.component.ts